import router from "@/router";
import axios from "axios";
import label from "@/lang/StaticLabels.js";
import alert from "@/lang/AlertMessages.js";
const psaleUrl = "sale/api/v1/";

export default {
  // CRM Setting Actions ------------------------------------------------------------------
  getSetting({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/Setting")
      .then((res) => {
        commit("setSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // SALE Setting Actions ------------------------------------------------------------------
  getSaleSetting({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/sale/Setting")
      .then((res) => {
        commit("setSaleSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editSaleSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/sale/Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // saleType ------------------------------------------------------
  getSaleType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/SaleType")
      .then((res) => {
        commit("setSaleType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleTypeById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/SaleType/getBy" + data)
      .then((res) => {
        commit("setSaleTypeById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSaleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/SaleType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/SaleType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/SaleType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleTypeMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "basic/SaleType/MaxCode")
      .then((res) => {
        commit("setSaleTypeMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // seller ------------------------------------------------------
  getSeller({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/Seller ")
      .then((res) => {
        commit("setSeller", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSellerById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/Seller/" + data)
      .then((res) => {
        commit("setSellerById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSeller({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/Seller", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSeller({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/Seller", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSeller({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/Seller/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSellerMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "basic/Seller/MaxCode")
      .then((res) => {
        commit("setSellerMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sales agent ------------------------------------------------------
  getSalesAgents({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/Agent")
      .then((res) => {
        commit("setSalesAgents", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSalesAgentsById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/Agent/" + data)
      .then((res) => {
        commit("setSalesAgentsById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSalesAgents({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/Agent", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSalesAgents({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/Agent", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSalesAgents({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/Agent/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSalesAgentsMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "basic/Agent/MaxCode")
      .then((res) => {
        commit("setSalesAgentsMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sale price policy ------------------------------------------------------
  getSalePricePolicy({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/SalePricePolicy ")
      .then((res) => {
        commit("setSalePricePolicy", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSalePricePolicyById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/SalePricePolicy/getBy" + data)
      .then((res) => {
        commit("setSalePricePolicyById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSalePricePolicyCommodity({ dispatch, commit }, data) {
    axios
      .get(
        psaleUrl + "basic/SalePricePolicyCommodity/GetCommodityPrice?" + data,
      )
      .then((res) => {
        commit("setSalePricePolicyCommodity", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSalePricePolicyDetail({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/SalePricePolicyCommodity" + data)
      .then((res) => {
        commit("setSalePricePolicyDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSalePricePolicyDetailById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/SalePricePolicyCommodity" + data)
      .then((res) => {
        commit("setSalePricePolicyDetailById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSalePricePolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/SalePricePolicy", data)
      .then((res) => {
        if (res && res.status === 200) {
          router.push({
            name: "PSALESalePricePolicyEdit",
            params: { id: res.data.data },
          });
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addSalePricePolicyDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/SalePricePolicyCommodity/", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSalePricePolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/SalePricePolicy", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSalePricePolicyDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/SalePricePolicyCommodity", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSalePricePolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/SalePricePolicy/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSalePricePolicyDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/SalePricePolicyCommodity/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSalePricePolicyMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "basic/SalePricePolicy/MaxCode")
      .then((res) => {
        commit("setSalePricePolicyMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeGrouppolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/SalePricePolicy/AddGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelSalePricePolicy({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/salePricePolicy/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: alert.success.submit,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // discount policy ------------------------------------------------------
  getDiscountPolicy({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/DiscountPolicy ")
      .then((res) => {
        commit("setDiscountPolicy", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDiscountPolicyById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/DiscountPolicy/getBy" + data)
      .then((res) => {
        commit("setDiscountPolicyById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDiscountPolicyDetail({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/DiscountPolicyCommodity" + data)
      .then((res) => {
        commit("setDiscountPolicyDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDiscountPolicyDetailById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/DiscountPolicyCommodity" + data)
      .then((res) => {
        commit("setDiscountPolicyDetailById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDiscountPolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/DiscountPolicy", data)
      .then((res) => {
        if (res && res.status === 200) {
          router.push({
            name: "PSALEDiscountPolicyEdit",
            params: { id: res.data.data },
          });
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDiscountPolicyDetailDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/DiscountPolicyCommodity", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDiscountPolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/DiscountPolicy", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDiscountPolicyDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/DiscountPolicyCommodity", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDiscountPolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/DiscountPolicy/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSALEDiscountPolicyList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDiscountPolicyDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/DiscountPolicyCommodity/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDiscountPolicyMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "basic/DiscountPolicy/MaxCode")
      .then((res) => {
        commit("setDiscountPolicyMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // gift policy ------------------------------------------------------
  getGiftPolicy({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/GiftPolicy ")
      .then((res) => {
        commit("setGiftPolicy", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getGiftPolicyById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/GiftPolicy/getBy" + data)
      .then((res) => {
        commit("setGiftPolicyById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getGiftPolicyDetail({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/GiftPolicyCommodity" + data)
      .then((res) => {
        commit("setGiftPolicyDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getGiftPolicyDetailById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/GiftPolicyCommodity" + data)
      .then((res) => {
        commit("setGiftPolicyDetailById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addGiftPolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/GiftPolicy", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSALEGiftsPolicyList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addGiftPolicyDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/GiftPolicyCommodity/", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteGiftPolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/GiftPolicy", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteGiftPolicyDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/GiftPolicyCommodity", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editGiftPolicy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/GiftPolicy/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSALEGiftsPolicyList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editGiftPolicyDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/GiftPolicyCommodity/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getGiftPolicyMaxCode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "basic/GiftPolicy/MaxCode?headerGroupId=" + data)
      .then((res) => {
        commit("setGiftPolicyMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sample excel files ---------------------------------------------
  getExcelSample({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/ExcelSample")
      .then((res) => {
        commit("setExcelSample", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getExcelSampleById({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/ExcelSample/" + data)
      .then((res) => {
        commit("setExcelSampleById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addExcelSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/ExcelSample", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteExcelSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/ExcelSample", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editExcelSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/ExcelSample/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcel({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/ExcelSample/ImportFromExcel", data)
      .then((res) => {
        if (res.status === 200) {
          commit("setExcelSampleData", res.data.data);
        }
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getExcelSampleDetail({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/ExcelSampleDetail?" + data)
      .then((res) => {
        commit("setExcelSampleDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addExcelSampleDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/ExcelSampleDetail", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editExcelSampleDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/ExcelSampleDetail/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteExcelSampleDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/ExcelSampleDetail", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getExcelSampleDetailValidator({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "basic/ExcelSampleDetail/CheckValidator/" + data)
      .then((res) => {
        commit("setExcelSampleDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExcelSampleDetailFile({ dispatch }, data) {
    axios
      .get(psaleUrl + "basic/ExcelSample/GenerateExcelTemplate?" + data, {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "excelSample.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // preFactor ------------------------------------------------------
  getPreFactor({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "operation/Order?" + data)
      .then((res) => {
        commit("setPreFactor", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPreFactorById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/Order/" + data)
      .then((res) => {
        commit("setPreFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPreFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/Order", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePreFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/Order", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPreFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/Order/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPreFactorMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/Order/MaxCode")
      .then((res) => {
        commit("setPreFactorMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPreFactorSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/Order/get/" + data)
      .then((res) => {
        commit("setPreFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPreFactorNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/Order/Navigation?" + data)
      .then((res) => {
        commit("setPreFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintPreFactor({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(psaleUrl + "operation/Order/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // pre factor attachment --------------------------------------------------
  getPreFactorAttachment({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/orderAttachment?" + data)
      .then((res) => {
        commit("setPreFactorAttachment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPreFactorAttachmentById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/orderAttachment/" + data)
      .then((res) => {
        commit("setPreFactorAttachmentById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPreFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/orderAttachment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePreFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/orderAttachment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPreFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/orderAttachment/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //PreFactor Notes ---------------------------------------------
  getPreFactorNotes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "operation/OrderDocument?orderId=" + data)
      .then((res) => {
        commit("setPreFactorNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPreFactorNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/OrderDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePreFactorNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/OrderDocument", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPreFactorNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/OrderDocument/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Reports ------------------------------------------------------
  getSalesStatisticsByCustomersReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/SalesStatisticsByCustomersReport?" + data)
      .then((res) => {
        commit("setSalesStatisticsByCustomersReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSalesQuantityReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/SalesQuantityReport?" + data)
      .then((res) => {
        commit("setSalesQuantityReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCustomerSalesSingleProductReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/CustomerSalesSingleProductReport?" + data)
      .then((res) => {
        commit("setCustomerSalesSingleProductReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAggregatedCustomerProductSalesCustomerListReport({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/AggregatedCustomerProductSalesCustomerListReport")
      .then((res) => {
        commit(
          "setAggregatedCustomerProductSalesCustomerListReport",
          res.data.data,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAggregatedCustomerProductSalesCommodityListReport(
    { dispatch, commit },
    data,
  ) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        psaleUrl +
          "Report/AggregatedCustomerProductSalesCommodityListReport?" +
          data,
      )
      .then((res) => {
        commit(
          "setAggregatedCustomerProductSalesCommodityListReport",
          res.data.data.items,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCustomerCommoditySaleReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/CustomerCommoditySaleReport?" + data)
      .then((res) => {
        commit("setCustomerCommoditySaleReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCustomerCommoditySaleFactorListReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/CustomerCommoditySaleFactorListReport?" + data)
      .then((res) => {
        commit("setCustomerCommoditySaleFactorListReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBasedOnSaleManagerListReport({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/BasedOnSaleManagerListReport")
      .then((res) => {
        commit("setBasedOnSaleManagerListReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBasedOnSaleManagerDetailReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/BasedOnSaleManagerDetailReport?" + data)
      .then((res) => {
        commit("setBasedOnSaleManagerDetailReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSalesManagerCollaborationPercentageReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        psaleUrl + "Report/SalesManagerCollaborationPercentageReport?" + data,
      )
      .then((res) => {
        commit(
          "setSalesManagerCollaborationPercentageReport",
          res.data.data.items,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReportOfCreditorsAndDebtorsBasedOnSalesManagers(
    { dispatch, commit },
    data,
  ) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        psaleUrl +
          "Report/ReportOfCreditorsAndDebtorsBasedOnSalesManagers?" +
          data,
      )
      .then((res) => {
        commit(
          "setReportOfCreditorsAndDebtorsBasedOnSalesManagers",
          res.data.data.items,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCustomerSalesReportBasedOnSalesManagers({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/CustomerSalesReportBasedOnSalesManagers?" + data)
      .then((res) => {
        commit(
          "setCustomerSalesReportBasedOnSalesManagers",
          res.data.data.items,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getProductProfitReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/ProductProfitReport?" + data)
      .then((res) => {
        commit("setProductProfitReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getGrossProfitReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/GrossProfitReport?" + data)
      .then((res) => {
        commit("setGrossProfitReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getProductProfitByProductGroupReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/ProductProfitReportByProductGroup?" + data)
      .then((res) => {
        commit("setProductProfitByProductGroupReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getGrossProfitByInvoiceProductCustomerReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        psaleUrl + "Report/GrossProfitReportByInvoiceProductCustomer?" + data,
      )
      .then((res) => {
        commit(
          "setGrossProfitByInvoiceProductCustomerReport",
          res.data.data.items,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleByAgentReport({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/ReportByAgentList")
      .then((res) => {
        commit("setSaleByAgentReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleByAgentDetailReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/ReportByAgent?" + data)
      .then((res) => {
        commit("setSaleByAgentDetailReport", res.data.data.items);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getComprehensiveSalesInvoiceReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/ComprehensiveSalesInvoiceReport?" + data)
      .then((res) => {
        commit("setComprehensiveSalesInvoiceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getComprehensiveProductSalesReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/ComprehensiveProductSalesReport?" + data)
      .then((res) => {
        commit("setComprehensiveProductSalesReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAwardsGrantedCommodityListReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/AwardsGrantedCommodityListReport?" + data)
      .then((res) => {
        commit("setAwardsGrantedCommodityListReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAwardsGrantedReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/AwardsGrantedReport?" + data)
      .then((res) => {
        commit("setAwardsGrantedReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleByVisitorList({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/ReportByVisitorList")
      .then((res) => {
        commit("setSaleByVisitorList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleByVisitorReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/ReportByVisitor?" + data)
      .then((res) => {
        commit("setSaleByVisitorReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAddMinusReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/addMinusReport?" + data)
      .then((res) => {
        commit("setAddMinusReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCustomerProfitReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/CustomerProfitReport?" + data)
      .then((res) => {
        commit("setCustomerProfitReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFactorProfitReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "Report/FactorProfitReport?" + data)
      .then((res) => {
        commit("setFactorProfitReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sale factor ------------------------------------------------------
  getSaleFactor({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "operation/SaleFactor?" + data)
      .then((res) => {
        commit("setSaleFactor", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleFactorById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/SaleFactor/" + data)
      .then((res) => {
        commit("setSaleFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleFactorForCopy({ dispatch }, id) {
    return axios
      .get(psaleUrl + "operation/SaleFactor/" + id)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/SaleFactor", data)
      .then((res) => {
        commit("setSaleFactorId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addSaleFactorReturn({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(psaleUrl + "operation/SaleFactor/Return", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/SaleFactor", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/SaleFactor/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleFactorMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/SaleFactor/MaxCode")
      .then((res) => {
        commit("setSaleFactorMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleFactorSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/SaleFactor/get/" + data)
      .then((res) => {
        commit("setSaleFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleFactorNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/SaleFactor/Navigation?" + data)
      .then((res) => {
        commit("setSaleFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  saleFactorCancelOperation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(
        psaleUrl + "operation/SaleFactor/CancelOperation?status=" + data.status,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  saleFactorConfirmOperation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        psaleUrl +
          "operation/SaleFactor/ConfirmOperation?status=" +
          data.status,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  saleFactorSortCode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/SaleFactor/SortCode", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintSaleFactor({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(psaleUrl + "operation/SaleFactor/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReadPreFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/SaleFactor/PreFactor/" + data)
      .then((res) => {
        commit("setReadPreFactor", res.data.data);
        dispatch(
          "successPOSTHandlerSilent2",
          {
            server: res,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleFactorVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/SaleFactor/GetAddVoucher", data)
      .then((res) => {
        commit("setSaleFactorVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addSaleFactorVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/SaleFactor/IssuanceVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleFactorVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/SaleFactor/DeleteVoucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sale factor commission --------------------------------------------------
  getSaleFactorCommission({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/SaleFactorCommission?" + data)
      .then((res) => {
        commit("setSaleFactorCommission", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleFactorCommissionById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/SaleFactorCommission/" + data)
      .then((res) => {
        commit("setSaleFactorCommissionById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSaleFactorCommission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/SaleFactorCommission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleFactorCommission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/SaleFactorCommission", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleFactorCommission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/SaleFactorCommission/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sale factor attachment --------------------------------------------------
  getSaleFactorAttachment({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/SaleFactorAttachment?" + data)
      .then((res) => {
        commit("setSaleFactorAttachment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleFactorAttachmentById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/SaleFactorAttachment/" + data)
      .then((res) => {
        commit("setPreFactorAttachmentById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSaleFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/SaleFactorAttachment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/SaleFactorAttachment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/SaleFactorAttachment/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Sale Notes ---------------------------------------------
  getSaleNotes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "operation/SaleFactorDocument?orderId=" + data)
      .then((res) => {
        commit("setSaleNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSaleNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/SaleFactorDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/SaleFactorDocument", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/SaleFactorDocument/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // return sale factor ------------------------------------------------------
  getReturnSaleFactor({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "operation/ReturnSaleFactor?" + data)
      .then((res) => {
        commit("setReturnSaleFactor", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReturnSaleFactorById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/ReturnSaleFactor/" + data)
      .then((res) => {
        commit("setReturnSaleFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReturnSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/ReturnSaleFactor", data)
      .then((res) => {
        commit("setReturnSaleFactorId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReturnSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/ReturnSaleFactor", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReturnSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/ReturnSaleFactor/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReturnSaleFactorMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/ReturnSaleFactor/MaxCode")
      .then((res) => {
        commit("setReturnSaleFactorMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReturnSaleFactorSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/ReturnSaleFactor/get/" + data)
      .then((res) => {
        commit("setReturnSaleFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReturnSaleFactorNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/ReturnSaleFactor/Navigation?" + data)
      .then((res) => {
        commit("setReturnSaleFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  returnSaleFactorCancelOperation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(
        psaleUrl +
          "operation/ReturnSaleFactor/CancelOperation?status=" +
          data.status,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  returnSaleFactorConfirmOperation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        psaleUrl +
          "operation/ReturnSaleFactor/ConfirmOperation?status=" +
          data.status,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  returnSaleFactorSortCode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/ReturnSaleFactor/SortCode", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintReturnSaleFactor({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        psaleUrl + "operation/ReturnSaleFactor/Print/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReturnSaleFactorVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/ReturnSaleFactor/GetAddVoucher", data)
      .then((res) => {
        commit("setReturnSaleFactorVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReturnSaleFactorVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/ReturnSaleFactor/IssuanceVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReturnSaleFactorVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/ReturnSaleFactor/DeleteVoucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReadSaleFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "operation/ReturnSaleFactor/GetSaleFactor/" + data)
      .then((res) => {
        commit("setReadSaleFactor", res.data.data);
        dispatch(
          "successPOSTHandlerSilent2",
          {
            server: res,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReturnSaleFactorGroupReceiptCartable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        psaleUrl +
          "operation/ReturnSaleFactor/GroupReceiptCartable?OnlyDetail=true" +
          data,
      )
      .then((res) => {
        commit("setReturnSaleFactorGroupReceiptCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReturnSaleFactorReceiptRows({ dispatch }, code) {
    return axios
      .get(
        psaleUrl +
          "operation/ReturnSaleFactor/GroupReceiptCartable?OnlyDetail=true&fromCode=" +
          code +
          "&toCode=" +
          code,
      )
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getReturnSaleFactorForCopy({ dispatch }, id) {
    return axios
      .get(psaleUrl + "operation/ReturnSaleFactor/" + id)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addReturnSaleFactorGroupReceipt({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(psaleUrl + "operation/ReturnSaleFactor/CreateGroupReceipt", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //ReturnSaleFactor Notes ---------------------------------------------
  getReturnSaleFactorNotes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "operation/ReturnSaleFactorDocument?orderId=" + data)
      .then((res) => {
        commit("setReturnSaleFactorNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addReturnSaleFactorNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/ReturnSaleFactorDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReturnSaleFactorNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/ReturnSaleFactorDocument", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReturnSaleFactorNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        psaleUrl + "operation/ReturnSaleFactorDocument/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sale factor attachment --------------------------------------------------
  getReturnSaleFactorAttachment({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/ReturnSaleFactorAttachment?" + data)
      .then((res) => {
        commit("setReturnSaleFactorAttachment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReturnSaleFactorAttachmentById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/ReturnSaleFactorAttachment/" + data)
      .then((res) => {
        commit("setReturnSaleFactorAttachmentById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReturnSaleFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/ReturnSaleFactorAttachment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReturnSaleFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/ReturnSaleFactorAttachment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReturnSaleFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        psaleUrl + "operation/ReturnSaleFactorAttachment/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sale factor commission --------------------------------------------------
  getReturnSaleFactorCommission({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/ReturnSaleFactorCommission?" + data)
      .then((res) => {
        commit("setReturnSaleFactorCommission", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReturnSaleFactorCommissionById({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/ReturnSaleFactorCommission/" + data)
      .then((res) => {
        commit("setReturnSaleFactorCommissionById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReturnSaleFactorCommission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "operation/ReturnSaleFactorCommission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReturnSaleFactorCommission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "operation/ReturnSaleFactorCommission", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReturnSaleFactorCommission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        psaleUrl + "operation/ReturnSaleFactorCommission/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // reports ------------------------------------------------
  getSaleReportByProduct({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/SaleReportByProduct?" + data)
      .then((res) => {
        commit("setSaleReportByProduct", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSalesOfficeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "Report/SalesOffice?" + data)
      .then((res) => {
        commit("setSalesOfficeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // BuyType ------------------------------------------------------
  getBuyTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "basic/BuyType")
      .then((res) => {
        commit("setBuyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addBuyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(psaleUrl + "basic/BuyType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBuyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "basic/BuyType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBuyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(psaleUrl + "basic/BuyType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyTypeCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(psaleUrl + "basic/BuyType/GetMaxCode")
      .then((res) => {
        commit("setBuyTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Sale Cartable Management ..................................................................................
  getSaleFactorManagementCartable({ dispatch, commit }, data) {
    axios
      .get(
        psaleUrl +
          "operation/SaleFactor/SaleFactorManagementCartableList?" +
          data,
      )
      .then((res) => {
        commit("setSaleFactorManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  saleManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/SaleFactor/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //SaleReturn Cartable Management ..................................................................................
  getSaleReturnManagementCartable({ dispatch, commit }, data) {
    axios
      .get(
        psaleUrl +
          "operation/ReturnSaleFactor/ReturnSaleFactorManagementCartableList?" +
          data,
      )
      .then((res) => {
        commit("setSaleReturnManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  saleReturnManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(psaleUrl + "operation/ReturnSaleFactor/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Confirm SaleFactor Cartable ................................................................................
  getConfirmSaleFactorCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "operation/SaleFactor/SaleFactorCartable")
      .then((res) => {
        commit("setConfirmSaleFactorCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  saleFactorChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(psaleUrl + "operation/SaleFactor/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleFactorGroupDraftCartable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        psaleUrl +
          "operation/SaleFactor/GroupDraftCartable?OnlyDetail=true" +
          data,
      )
      .then((res) => {
        commit("setSaleFactorGroupDraftCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleFactorDraftRows({ dispatch }, code) {
    return axios
      .get(
        psaleUrl +
          "operation/SaleFactor/GroupDraftCartable?OnlyDetail=true&fromCode=" +
          code +
          "&toCode=" +
          code,
      )
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addSaleFactorGroupDraft({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(psaleUrl + "operation/SaleFactor/CreateGroupDraft", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return true;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  saleFactorReturnStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(psaleUrl + "operation/SaleFactor/ReturnStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Confirm ReturnSaleFactor Cartable ................................................................................
  getConfirmReturnSaleFactorCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(psaleUrl + "operation/ReturnSaleFactor/ReturnSaleFactorCartable")
      .then((res) => {
        commit("setConfirmSaleReturnCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  returnSaleFactorChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(psaleUrl + "operation/ReturnSaleFactor/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  returnSaleFactorReturnStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(psaleUrl + "operation/ReturnSaleFactor/ReturnStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //CartableLog ..................................................................................
  getCartableLog({ dispatch, commit }, data) {
    axios
      .get(psaleUrl + "operation/CartableLog?" + data)
      .then((res) => {
        commit("setCartableLog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
};
